






// @ is an alias to /src
import { Component } from "vue-property-decorator";
import HacoCommon from "../HacoCommon";
import CustomList from "@/components/CustomList.vue";
@Component({
  components: {
    CustomList
  }
})
export default class Custom extends HacoCommon {
  // put something
}
